import { Button } from "@mui/material"
import globals from "../globals";

const BlueButton = ({text, mTop, pX, href, size, sx, onClick, disabled}) => {

    return (
        <Button variant='contained' href={href} onClick={onClick} type='submit' size={size || 'large'} disabled={disabled} sx={{
            mt: mTop, px: pX, backgroundColor: globals.colors.darkBlue, textTransform: 'none', '&:hover': {
                backgroundColor: globals.colors.lightBlue,
            },
            ...(sx || {})
        }}> {text}</Button>
    );
}

export default BlueButton;